Ext.define('SA.CountryFactory', {
    singleton: true,

    cfg: {
        USA: {
            name: 'USA',
            locationSeries: 'usa:840',
            metersPerRadiusUnit: 1609.344
        },

        CAN: {
            name: 'Canada',
            locationSeries: 'can:124',
            metersPerRadiusUnit: 1000
        }
    },

    create({code, data}) {
        var cfg = this.cfg[code],
            latestRelease = Math.max(...Object.keys(data.censusReleases).map(Number)),
            censusReleases = this.getCensusReleases(data.censusReleases, data.availableGeographicUnits),
            params = {...cfg, ...data, code, latestRelease, censusReleases};

        return new SA.model.Country(params);
    },

    getCensusReleases(releases, availableGeoUnits) {
        return SA.Object.mapValues(releases, value => {
            var geographicUnits = value.geographicUnits.map(unit => getGeoUnitItem(unit)),
                latestGeographicRelease = Math.max(...value.geographicReleases);

            return {...value, geographicUnits, latestGeographicRelease};
        });

        function getGeoUnitItem(unit) {
            var id = unit.geographicUnit ?? unit,
                unit = availableGeoUnits.find(unit => id === unit.geographicUnit),
                singularName = Ext.util.Format.singularize(unit.name);

            return {id, singularName, ...unit};
        }
    }
});